<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">

                        <el-input
                            size="small"
                            style="width:220px;margin-left:0px"
                            placeholder="请输入用户 姓名/手机号"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                            
                            <el-date-picker
                            style="width:210px;margin-left:20px"
                            size="small"
                            :clearable="true"
                            v-model="queryModel.lastUseTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="最后任务日期小于该日期">
                            </el-date-picker>

                        <el-date-picker
                        style="width:210px;margin-left:20px"
                        size="small"
                            :clearable="true"
                            v-model="queryModel.lastRechargeTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="最后充值日期小于该日期">
                            </el-date-picker>
                        <el-tag size="" style="margin-left:20px">当前余额小于：</el-tag>

                             <el-input
                            size="small"
                            style="width:120px;margin-left:10px"
                            prefix-icon="el-icon-money"
                            @keydown.enter.native="query"
                            v-model="queryModel.balance">
                        </el-input>

                        

                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                    
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :height="bodyHeight-110"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            prop="Id"
                            label="Id">
                        </el-table-column>
                        <el-table-column
                            prop="Name"
                            label="名称">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            label="手机">
                        </el-table-column>
                        <el-table-column
                            label="余额">
                            <template slot-scope="scope">
                                <el-link icon="el-icon-money" type="primary">￥{{scope.row.Balance}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="信用额度">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.Advance==0" icon="el-icon-bank-card" type="info">暂无</el-link>
                                <el-link v-else icon="el-icon-bank-card"  type="primary">￥{{scope.row.Advance}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="赔付账户">
                            <template slot-scope="scope">
                                <el-link icon="el-icon-money" type="primary">￥{{scope.row.Payout}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="流失天数">
                            <template slot-scope="scope">
                                <el-tag  effect="dark" size="small" v-if="scope.row.ChurnDays<=1"   type="success">{{scope.row.ChurnDays}}</el-tag>
                                <el-tag  effect="dark" size="small" v-else-if="scope.row.ChurnDays<7"   type="warning">{{scope.row.ChurnDays}}</el-tag>
                                <el-tag  effect="dark" size="small" v-else-if="scope.row.ChurnDays<=35"   type="danger">{{scope.row.ChurnDays}}</el-tag>
                                 <el-tag  effect="dark" size="small" v-else type="info">>35</el-tag>


                            </template>
                        </el-table-column>
                        <el-table-column
                            label="注册日期">
                                  <template slot-scope="scope">
                                    <el-tag size="small" v-if="scope.row.CreateTime==null"   type="info">暂无</el-tag>

                                    <template v-else>
                                        <i class="el-icon-time"></i>
                                        <span style="margin-left: 10px">{{  scope.row.CreateTime.split(' ')[0] }}</span>
                                    </template>
                                </template>
                        </el-table-column>
                        <el-table-column
                            label="最后任务日期">
                                  <template slot-scope="scope">
                                    <el-tag size="small" v-if="scope.row.LastUsetTime==null"   type="info">暂无</el-tag>

                                    <template v-else>
                                        <i class="el-icon-time"></i>
                                        <span style="margin-left: 10px">{{  scope.row.LastUsetTime.split(' ')[0] }}</span>
                                    </template>
                                </template>
                        </el-table-column>
                        <el-table-column
                            label="最后充值日期">
                                  <template slot-scope="scope">
                                    <el-tag  size="small" v-if="scope.row.LastRechargeTime==null"   type="info">暂无</el-tag>
                                    <template v-else>
                                        <i class="el-icon-time"></i>
                                        <span style="margin-left: 10px">{{  scope.row.LastRechargeTime.split(' ')[0] }}</span>
                                    </template>
                                </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { memberGetMemberData} from '@/request.js'

export default {
    components: {
    },
    data(){
        return {
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                lastUseTime:"",
                lastRechargeTime:"",
                balance:0,
            },
            tableData:[],
            moneyTotal:0,
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-110;
        
    },
    mounted(){

        this.query();
    },
    methods: {
        query(){
            this.isLoading=true;
            memberGetMemberData({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                lastUseTime:this.queryModel.lastUseTime==""?null:this.queryModel.lastUseTime,
                lastRechargeTime:this.queryModel.lastRechargeTime==""?null:this.queryModel.lastRechargeTime,
                balance:this.queryModel.balance,
            },(res)=>{
                this.tableData=res.Result;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                type:1,
                createTimes:[],
            }
        },
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>